import { Hash } from "@siteimprove/alfa-hash";
/**
 * @public
 */
export class FNV extends Hash {
    static empty() {
        return new FNV();
    }
    _hash = 2166136261;
    constructor() {
        super();
    }
    finish() {
        return this._hash >>> 0; // Convert to unsigned 32-bit integer
    }
    write(data) {
        let hash = this._hash;
        for (const octet of data) {
            hash ^= octet;
            hash +=
                (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
        }
        this._hash = hash;
        return this;
    }
    equals(value) {
        return value instanceof FNV && value._hash === this._hash;
    }
}
//# sourceMappingURL=fnv.js.map